// ====================================================
// src/components/block/liveStreamManagement/enchainements/IrisEnchainement.tsx
//
// Un cercle centré grossit jusqu'à couvrir tout le cadre, révélant le preview
// derrière. Pas de réglage pour l'instant (pas de direction) — même modèle
// que Fondu côté config.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface IrisConfig {}

class IrisEnchainementImpl extends Enchainement<IrisConfig> {
  readonly id = 'iris';
  readonly label = 'Iris';
  readonly icon = 'Circle';
  readonly defaultConfig: IrisConfig = {};

  render(input: EnchainementRenderInput, _config: IrisConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;

    // Flux final fixe en fond, plein cadre.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    if (progress <= 0) return;

    const cx = width / 2, cy = height / 2;
    // Rayon nécessaire pour couvrir les coins du cadre, quel que soit son ratio.
    const maxR = Math.sqrt(cx * cx + cy * cy);

    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, maxR * progress, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls(_props: EnchainementControlProps<IrisConfig>) {
    return null;
  }
}

export const irisEnchainement = new IrisEnchainementImpl();
